import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

function Unauthorized() {
  const navigate = useNavigate();
  const { currentUser, isSuperAdmin } = useAuth();

  const handleNavigateHome = () => {
    if (isSuperAdmin()) {
      navigate('/admin');
    } else {
      navigate('/');
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={6}>
          <Card className="shadow-sm">
            <Card.Body className="text-center p-5">
              <FontAwesomeIcon 
                icon={faExclamationTriangle} 
                className="text-warning mb-4" 
                style={{ fontSize: '3rem' }} 
              />
              <h2>Access Denied</h2>
              <p className="lead mb-4">
                You don't have permission to access this page.
              </p>
              <Button onClick={handleNavigateHome} variant="primary">
                Go to Dashboard
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Unauthorized;
